import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgArrowLeftOutline = function SvgArrowLeftOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5303 5.21967C10.8232 5.51256 10.8232 5.98744 10.5303 6.28033L5.56066 11.25H20.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H5.56066L10.5303 17.7197C10.8232 18.0126 10.8232 18.4874 10.5303 18.7803C10.2374 19.0732 9.76256 19.0732 9.46967 18.7803L3.21967 12.5303C2.92678 12.2374 2.92678 11.7626 3.21967 11.4697L9.46967 5.21967C9.76256 4.92678 10.2374 4.92678 10.5303 5.21967Z"
  })));
};

export { SvgArrowLeftOutline as ReactComponent };
//# sourceMappingURL=arrow-left-outline.svg.js.map
